import SubscribeForm from '@/components/feature/SubscribeForm';

export default function SubscribeSection() {
  return (
    <section aria-label="订阅爆料" className="mx-auto mt-16 w-full max-w-[1280px] px-4 md:mt-20 md:px-6">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1fr]">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
              <span className="h-1 w-6 rounded-full bg-primary-500" aria-hidden="true"></span>
              抢先订阅
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              第一手消息，直接送到你的邮箱
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
              订阅看料99 的更新提醒，重要爆料发布时我们会第一时间通知你，不做广告轰炸，随时可以退订。
            </p>
            <div className="mt-6 max-w-lg">
              <SubscribeForm />
            </div>
          </div>
          <div className="relative hidden lg:block">
            <img
              src="https://readdy.ai/api/search-image?query=cozy%20warm%20workspace%20with%20open%20notebook%2C%20cup%20of%20tea%20and%20a%20smartphone%20showing%20a%20notification%2C%20soft%20amber%20afternoon%20light%2C%20editorial%20lifestyle%20photography%2C%20terracotta%20and%20cream%20tones&width=900&height=800&seq=kanliao-subscribe-13&orientation=portrait"
              alt="订阅看料99 更新提醒的温馨工作场景"
              title="看料99 订阅提醒"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}